export const getAppointmentDetails = (message: string) => {
  const result = {
    baseMessage: message,
    dateTime: "",
    location: "",
    mode: "",
  };

  try {
    const [basePart, rest] = message?.split("On ");
    result.baseMessage = basePart?.trim() || message;

    const isReschedule = message.includes("New Schedule:");

    if (isReschedule) {
      const [msg, newSchedulePart] = message?.split("New Schedule:") || [];
      if (newSchedulePart) {
        const [newDateTime, oldSchedulePart] = newSchedulePart?.split("Old Schedule:") || [];
        if (oldSchedulePart) {
          const [oldDateTime, locationMode] = oldSchedulePart?.split("Location:") || [];
          
          result.baseMessage = msg?.trim() || result.baseMessage;
          result.dateTime = `New: ${newDateTime?.trim()} | Old: ${oldDateTime?.trim()}`;

          if (locationMode) {
            const [location, mode] = locationMode?.split("/");
            result.location = location?.trim();
            result.mode = mode?.trim();
          }
        }
      }
    } else if (rest) {
      const [dateTimePart, locationModePart] = rest?.split("Location:") || [];
      result.dateTime = dateTimePart?.trim();

      if (locationModePart) {
        const [location, mode] = locationModePart?.split("/");
        result.location = location?.trim();
        result.mode = mode?.trim();
      }
    }
  } catch (error) {
    console.error("Error parsing appointment details:", error);
  }

  return result;
};